import { ScriptableScaleContext } from "chart.js";

export interface ITrendYAxisVisibilityOptions {
  uniqueUnitCount: number;
  allSeriesAreAmplitudePhase: boolean;
  showMultitrendScales: boolean;
}

export function getTrendYAxisDisplay({
  uniqueUnitCount,
  allSeriesAreAmplitudePhase,
  showMultitrendScales,
}: ITrendYAxisVisibilityOptions): "auto" | false {
  if (uniqueUnitCount < 1) {
    return false;
  }

  return uniqueUnitCount === 1 || (uniqueUnitCount === 2 && allSeriesAreAmplitudePhase) || showMultitrendScales
    ? "auto"
    : false;
}

export function shouldDrawTrendYAxisGrid({ chart, scale }: ScriptableScaleContext): boolean {
  const firstVisibleDataset = chart.data.datasets.find((_, index) => chart.isDatasetVisible(index));

  return !!firstVisibleDataset && "yAxisID" in firstVisibleDataset && firstVisibleDataset.yAxisID === scale.id;
}

export function getTrendYAxisPosition(index: number, showMultitrendScales: boolean): "left" | "right" {
  return showMultitrendScales || index % 2 === 0 ? "left" : "right";
}
